import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.affiliateTrainingSteps.index)
      .then((response) => {
        dispatch({ type: 'LOAD', affiliateTrainingSteps: response.data.data });
      });
  },

  create: (dispatch, formData, onSuccess, onError) => {
    axios
      .post(
        routes.api.affiliateTrainingSteps.create,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .then((response) => {
        dispatch({ type: 'CREATE', affiliateTrainingStep: response.data.data });
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  update: (dispatch, affiliateTrainingStepId, formData, onSuccess, onError) => {
    axios
      .patch(
        routes.api.affiliateTrainingSteps.update(affiliateTrainingStepId),
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .then((response) => {
        dispatch({ type: 'UPDATE', affiliateTrainingStep: response.data.data });
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  sort: (dispatch, list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    dispatch({
      type: 'SORT',
      affiliateTrainingSteps: result,
    });

    axios
      .patch(routes.api.affiliateTrainingSteps.sort, {
        affiliate_training_steps: result.map((item, index) => ({ id: item.id, index })),
      })
      .then((_response) => {});
  },

  destroy: (dispatch, affiliateTrainingStepId) => {
    axios
      .delete(routes.api.affiliateTrainingSteps.destroy(affiliateTrainingStepId))
      .then((_response) => {
        dispatch({ type: 'DESTROY', affiliateTrainingStepId });
      });
  },
};
